import React, { useState, useEffect, useMemo } from 'react';
import { Modal, Button, Col, Row, Card } from 'react-bootstrap';
import { useDispatch, useSelector } from 'react-redux';
import { Heading5, Icon, SearchInput } from '../../widgets';
import { searchWord } from '../../../helpers/common';
import { getUserOEMMakeList, OEMUserAssign } from '../../../actions/oem';

const AssignOEMModal = props => {
    const { onHide, userId } = props;
    const dispatch = useDispatch();

    const oemMakeList = useSelector((state) => state.oem.makeList.payload);
    const { isRequesting, payload: assignedMakeList } = useSelector((state) => state.oem.userOEM);

    const [assignedMakeIds, assignMakeId] = useState([]);
    const [isSaving, setIsSaving] = useState(false);
    const [searchText, setSearchText] = useState("");

    useEffect(() => {
        dispatch(getUserOEMMakeList({ user_id: userId }));
    }, []);

    useEffect(() => {
        if (assignedMakeList && assignedMakeList.length > 0) {
            assignMakeId(assignedMakeList.map(item => item.equipment_make_id));
        } else {
            assignMakeId([]);
        }
    }, [assignedMakeList]);

    const getFilteredMakeList = (makeList, searchText) => {
        return makeList.filter(e => (assignedMakeIds.indexOf(e.equipment_make_id) < 0 && searchWord(e.equipment_make_name, searchText)));
    }
    let filteredMakeList = useMemo(() => getFilteredMakeList(oemMakeList, searchText), [oemMakeList, assignedMakeIds, searchText]);

    const handleSave = () => {
        const params = { user_id: userId, equipment_make_id: (assignedMakeIds.length > 0) ? assignedMakeIds[0] : null };
        const onSuccess = () => { setIsSaving(false); onHide(); };
        setIsSaving(true);
        dispatch(OEMUserAssign(params, onSuccess));
    }

    const handleAssignOEM = (makeId) => assignMakeId([makeId]);
    const handleUnassignOEM = () => assignMakeId([]);

    const { saveDisabled, actionText } = useMemo(() => {
        if (assignedMakeIds.length > 0 && assignedMakeList.length > 0) {
            const alreadyAssignedMake = (assignedMakeList[0].equipment_make_id === assignedMakeIds[0]);
            return { saveDisabled: alreadyAssignedMake, actionText: alreadyAssignedMake ? 'Assign' : "Update" };
        } else if (assignedMakeList.length > 0 && assignedMakeIds.length === 0) {
            return { saveDisabled: false, actionText: 'Unassign' };
        }
        return { saveDisabled: assignedMakeIds.length === 0, actionText: 'Assign' };
    }, [assignedMakeIds, assignedMakeList]);

    return <Modal show={true} backdrop="static" onHide={onHide} size='lg' className="assign-farm-modal assign-oem-modal">
        <Modal.Header closeButton style={{ color: '#064d9e' }}>
            <Modal.Title>
                <Heading5>Assign OEM</Heading5>
            </Modal.Title>
        </Modal.Header>
        <Modal.Body>
            <Row>
                {isRequesting || assignedMakeIds.length === 0
                    ? <Col className="no-item-found">{isRequesting ? "Loading..." : "This user does not belong to any OEM"}</Col>
                    : <Col className="assigned-farms">
                        <Row>
                            {assignedMakeIds.map((item) => {
                                const makeItem = oemMakeList.find((e) => e.equipment_make_id === item);
                                const { equipment_make_name = null } = makeItem;
                                return (
                                    <div key={item} className="farm-title d-flex"
                                        style={{ background: "#002653" }}  >
                                        <p className="name">{equipment_make_name}</p>
                                        <i className="fa fa-times-circle" aria-hidden="true" title="Unselect"
                                            onClick={() => handleUnassignOEM()}></i>
                                    </div>
                                )
                            }
                            )}
                        </Row>
                    </Col>}
                <Col sm={4} md={4} lg={4} className="available-farms">
                    <div className="search-input">
                        <SearchInput className="w-100" onChange={searchText => setSearchText(searchText)} />
                    </div>

                    <div className={`m-0 farm-items`}>
                        {filteredMakeList.map(item => <Card key={item.equipment_make_id} className="farm-item">
                            <div>
                                <Row className="name m-0">{item.equipment_make_name}</Row>
                            </div>
                            <Button className="btn-success btn-sm add-btn" disabled={assignedMakeIds.length > 0} title={"Assign OEM"}
                                onClick={() => handleAssignOEM(item.equipment_make_id)}>Add</Button>
                        </Card>
                        )}
                    </div>
                </Col>
            </Row>
        </Modal.Body>
        <Modal.Footer>
            <Button variant='btn btn-danger btn-sm' onClick={onHide} ><i className="fa fa-times-circle"></i> Cancel</Button>
            <Button variant='btn  btn-primary btn-sm' disabled={saveDisabled} onClick={handleSave} ><Icon className="fa fa-floppy-o"></Icon>{isSaving ? " Saving..." : ` ${actionText}`}</Button>
        </Modal.Footer>
    </Modal>
};

export default AssignOEMModal;